/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserRatingControllerService {
    /**
     * @param remedyId
     * @returns boolean Check if feedback exists
     * @throws ApiError
     */
    public static userRatingControllerCheckFeedBackExists(
        remedyId: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/feedback-exists/{remedyId}',
            path: {
                'remedyId': remedyId,
            },
        });
    }
    /**
     * @param userId
     * @param vastuRemedyId
     * @param requestBody Create user rating request
     * @returns any Create user rating response
     * @throws ApiError
     */
    public static userRatingControllerCreateUserRating(
        userId: string,
        vastuRemedyId: string,
        requestBody: {
            rating: number;
            /**
             * User comment
             */
            comment?: string;
        },
    ): CancelablePromise<{
        /**
         * User rating id
         */
        id: string;
        rating: number;
        /**
         * User comment
         */
        comment?: string;
        /**
         * User ID
         */
        userId: string;
        /**
         * VastuRemedy ID
         */
        vastuRemedyId: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/user-rating/{userId}/{vastuRemedyId}',
            path: {
                'userId': userId,
                'vastuRemedyId': vastuRemedyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
